export default __webpack_public_path__ + "static/empty_news_2-7090003d928095539f797ae68fa89873.jpeg";